import type { AccountingEntry, WalletAccountingSyncTransaction } from '../models';

export type AccountingEntrySource = Pick<WalletAccountingSyncTransaction, 'accounting_entry' | 'accounting_entry_json'>;

/** Cadena JSON tal como viene del API o serializada desde el objeto. */
export function getAccountingEntryRawString(source: AccountingEntrySource): string {
  const raw = source.accounting_entry_json;
  if (raw != null && String(raw).trim() !== '') {
    return String(raw);
  }
  if (source.accounting_entry != null && typeof source.accounting_entry === 'object') {
    try {
      return JSON.stringify(source.accounting_entry, null, 2);
    } catch {
      return '';
    }
  }
  return '';
}

/** Objeto asiento parseado para la vista amigable. */
export function parseAccountingEntryObject(source: AccountingEntrySource): AccountingEntry | null {
  if (source.accounting_entry != null && typeof source.accounting_entry === 'object') {
    return source.accounting_entry;
  }
  const str = source.accounting_entry_json;
  if (str == null || String(str).trim() === '') {
    return null;
  }
  try {
    const parsed = JSON.parse(String(str)) as unknown;
    if (parsed != null && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed as AccountingEntry;
    }
  } catch {
    /* vacío */
  }
  return null;
}

export function hasAccountingEntryPayload(source: AccountingEntrySource): boolean {
  return getAccountingEntryRawString(source).trim() !== '';
}

/** Una sola línea para búsqueda (sin pretty-print). */
export function getAccountingEntrySearchBlob(source: AccountingEntrySource): string {
  const obj = parseAccountingEntryObject(source);
  if (obj) {
    try {
      return JSON.stringify(obj);
    } catch {
      return '';
    }
  }
  const raw = source.accounting_entry_json;
  return raw != null ? String(raw).replace(/\s+/g, ' ').trim() : '';
}
